import React from "react"
import "./styles.scss"
import { Helmet } from "react-helmet"

const PrivacyPolicy = ({ }) => {
  return <div className="screen-privacy-policy-container">
    <Helmet>
      <title>Privacy Policy</title>
    </Helmet>

    <p className="s1" style={{ textIndent: "0pt", lineHeight: "33pt", textAlign: "center" }}>

      Amaranth Bulgaria Mobile Application
    </p>
    <p className="s1" style={{ textIndent: "0pt", textAlign: "center" }}>

      Privacy Policy</p>
    <p style={{ paddingTop: '11pt', paddingLeft: '5pt', textIndent: '35pt', textAlign: 'justify' }}>
      This Privacy Policy is
      provided to users of the Amaranth Mobile Application in accordance with Art. 13 of Regulation 2016/679/EU of the
      European Parliament and of the Council of 27 April 2017 (General Data Protection Regulation).</p>
    <p style={{ paddingTop: '11pt', paddingLeft: '5pt', textIndent: '35pt', textAlign: 'justify' }}>
      The Administrator within the
      meaning of this Privacy Policy is Amaranth Bulgaria Ltd. It is registered in the Commercial Register and the
      Register of non-profit legal entities with the unique identification code: 131472007, VAT identification number:
      BG 131472007, with registered office and management address at 5 Khan Asparuh Str., Triaditsa district, 1463
      Sofia. Amaranth Bulgaria Ltd. is a registered Insurance Broker, entered in the Register of insurance
      intermediaries according to Certificate № 787-ZB / 26.11.2021 issued by the Financial Supervision Commission.
    </p>
    <p style={{ paddingTop: '11pt', paddingLeft: '5pt', textIndent: '35pt', textAlign: 'justify' }}>
      <a
        href="mailto:dpo@amarantbg.com" className="s2" target="_blank">
        In order to ensure compliance with the applicable
        legislation, Amaranth Bulgaria has appointed Gugushev &amp; Partners Law Firm as a data protection Official.
        For additional information and assistance in connection with the processing of your data or to exercise the
        rights under Articles 15-22 of Regulation 2016/679/EU, you can contact the Official at the following e-mail
        address: </a><a href="mailto:dpo@amarantbg.com" className="a" target="_blank">
        dpo@amarantbg.com</a><a
          href="mailto:dpo@amarantbg.com" className="s2" target="_blank">
        .</a></p>
    <p style={{ paddingTop: '11pt', paddingLeft: '5pt', textIndent: '35pt', textAlign: 'justify' }}>
      The Mobile Application
      functions as a system for providing insurance services at a distance. When registering in the Mobile Application
      and/or using it to conclude contracts for mediation in concluding insurance contracts, we process your personal
      data only for lawful purposes and only insofar as the processing is actually necessary to achieve these goals,
      as follows:</p>
    <ol id="l1">

      <li data-list-text="(1)">

        <p style={{ paddingTop: '11pt', paddingLeft: '20pt', textIndent: '-14pt', textAlign: 'justify' }}>
          names, e-mail
          address and contact telephone number - for the purposes of registration in the Mobile Application and
          verification of the user&#39;s identity;</p>
      </li>
      <li data-list-text="(2)">

        <p style={{ paddingTop: '11pt', paddingLeft: '20pt', textIndent: '-14pt', textAlign: 'justify' }}>
          data from identity
          documents and/or driving license such as names, sex, age, date of birth, citizenship, PIN/Personal ID
          number for a foreigner, permanent and current address; other data about you, e.g. a copy of the identity
          document or a driving license - for fulfillment of legal obligations of Amaranth Bulgaria Ltd. as an
          insurance intermediary.</p>
      </li>
      <li data-list-text="(3)">

        <p style={{ paddingTop: '11pt', paddingLeft: '20pt', textIndent: '-14pt', textAlign: 'justify' }}>
          data from identity
          documents (names, sex, age, date of birth, citizenship, PIN/Personal ID number for a foreigner,
          permanent and current address), information on insurance contracts concluded by the user, copy of the
          vehicle registration certificate, payment details (names, debit or credit card details), delivery
          address, order data in the Mobile Application, data from completed questionnaires, as well as data from
          additional requests for information - for the purposes of concluding contracts for awarding and
          providing insurance intermediary services at a distance, including for the purpose of taking steps to
          conclude insurance contracts on behalf of the user to which he/she is a party, as well as for the
          payment of the insurance premium or separate installments thereof, and for the purposes of other
          contracts with the user concluded at a distance regarding the functionalities offered by the Mobile
          Application (payment of fines to the Traffic Police, payment of tolls / vignettes, payment of parking
          fees, etc.);</p>
      </li>
      <li data-list-text="(4)">

        <p style={{ paddingTop: '11pt', paddingLeft: '20pt', textIndent: '-14pt', textAlign: 'justify' }}>
          e-mail, in
          accordance with the requirements of Art. 10 para. 2a and Art. 10a para. 4a of the Roads Act;
          registration number and country of registration for the vehicle for which the vignette sticker is
          purchased; data necessary for the electronic payment of the vignette sticker - for the purpose of
          providing a service for the electronic purchase of vignette stickers for the toll road network in the
          country, as well as for providing data to other controllers of data in connection with the performance
          of the obligations provided by law for AMARANT and the possibility of notifying the person in the event
          of using the toll road network in the country without the presence of a valid vignette sticker.</p>
      </li>
      <li data-list-text="(5)">

        <p style={{ paddingTop: "2pt", paddingLeft: "20pt", textIndent: "-14pt", textAlign: "justify" }}>
          we process contact
          information to inform you of changes in our General Terms and Conditions, as required by law, as well as
          for the purposes of direct marketing by sending e-mails based on your consent;</p>
      </li>
      <li data-list-text="(6)">

        <p style={{ paddingTop: '11pt', paddingLeft: '20pt', textIndent: '-14pt', textAlign: 'justify' }}>
          location data, in
          the cases when the user of the Mobile Application has activated the function for determining his/her
          location on his/her mobile phone and uses the service for payment for parking in the blue or green zone.
        </p>
      </li>
    </ol>
    <p className="s3" style={{ paddingTop: '11pt', paddingLeft: '20pt', textIndent: '-14pt', textAlign: 'justify' }}>
      [(7)] <span
        style={{ color: "#000" }}>
        we use data related to your behavior as a user of the Mobile Application for
        statistical purposes to evaluate how you use the Mobile Application, to analyze user behavior and improve
        our services, add new features and eliminate errors, as well as for targeted advertisement upon your
        explicit consent.</span></p>
    <p style={{ paddingTop: '11pt', paddingLeft: '5pt', textIndent: '35pt', textAlign: 'justify' }}>
      Part of the data processed,
      including data related to the health status of users when selling policies &quot;aimed for covering risks
      related to the life and health of insured persons&quot;, are special categories of data within the meaning of
      the General Data Protection Regulation and as such are handled only by privacy/confidentiality commitments.</p>
    <p style={{ paddingTop: '11pt', paddingLeft: '5pt', textIndent: '35pt', textAlign: 'justify' }}>
      Personal data collected
      through the Mobile Application is processed primarily by computer and electronic means, taking security measures
      to minimize the risks of destruction or loss, including accidental loss, of the data itself, unauthorized access
      or processing without consent, or processing that is inconsistent with the collection purposes set forth in this
      Privacy Policy. Depending on the chosen payment method, the payment data within the Mobile Application can be
      processed by electronic means via the virtual POS terminal service.</p>
    <p style={{ paddingTop: '11pt', paddingLeft: '5pt', textIndent: '35pt', textAlign: 'justify' }}>
      We will process your data only
      when we are able to prove the legal basis established in the General Data Protection Regulation and the
      applicable data protection laws in Bulgaria. Processing related to: 1) registration in the Mobile Application,
      including two-factor authentication, 2) sending orders, confirmation of sent orders, questionnaires related to
      orders and additional requests for information from Amaranth Bulgaria and the insurance company, 3) calculation
      of individual insurance premium and payment of insurance indemnity, 4) receipt of the Policy and related
      documents, 5) assistance in filing claims for indemnity under the respective insurance policy, 6) communication
      with consumers in connection with the use of the Mobile Application for purchasing insurance, 7 ) Notification
      of updates to our policies and conditions is based on the conclusion and implementation of brokerage contracts
      and/or insurance policies. The processing related to the provision of services outside the scope of the Law on
      the Provision of Financial Services at a Distance is carried out on the basis of the conclusion and
      implementation of a contract concluded at a distance through the Mobile Application. The processing related to
      the storage, drafting and exchange of insurance contracts, assignment contracts or other contracts concluded at
      a distance is carried out for the purpose of taking steps at the request of the user of the Mobile Application
      for Conclusion, as well as for the implementation of already concluded distance contracts.</p>
    <p style={{ paddingTop: '11pt', paddingLeft: '5pt', textIndent: '35pt', textAlign: 'justify' }}>
      The processing of personal
      data of the Mobile Application users, included in financial documents and reports, as well as in all other
      documents that we must prepare, collect and store in accordance with the applicable acts on accounting,
      anti-fraud and money laundering, is performed of our obligations under applicable tax, accounting and other
      laws.</p>
    <p style={{ paddingTop: '11pt', paddingLeft: '5pt', textIndent: '35pt', textAlign: 'justify' }}>
      The processing of users&#39;
      contact data is carried out for the purposes of notifying users of the expiration of purchased vignette
      stickers, as well as for driving on the toll road network of the country without a valid vignette sticker.
      Users’ contact data is also used for the purposes of direct marketing based on our legitimate interest in
      offering services (ours or our partners’), insofar as it is proportional to the legitimate interests of users.
      The processing of data related to the use of the Mobile Application is carried out on the basis of legitimate
      interest - to update and develop the Mobile Application, including to eliminate errors, as long as it is
      proportional to the legitimate interests of the users.</p>
    <p style={{ paddingTop: '11pt', paddingLeft: '5pt', textIndent: '35pt', textAlign: 'justify' }}>
      The processing of personal
      data provided by users when subscribing to our newsletter or for provision of targeted advertisement is carried
      out on the basis of the explicit consent of the user.</p>
    <p style={{ paddingTop: "2pt", paddingLeft: "5pt", textIndent: "35pt", textAlign: "justify" }}>
      Your data is processed as long
      as the processing is necessary for the respective purpose. In particular, personal data relating to service and
      insurance contracts shall be processed for the duration of the document concerned and then stored for an
      additional period of 11 years for tax and accounting purposes as well as for the purpose of resolving any
      disputes. All other personal data are processed until the main purpose of the processing is achieved, after
      which they are kept for an additional period of 5 years for tax and accounting purposes, as well as for the
      purpose of resolving disputes and settling legal claims, if applicable.</p>
    <p style={{ paddingTop: '11pt', paddingLeft: '5pt', textIndent: '35pt', textAlign: 'justify' }}>
      Execution of service contracts
      requires that we share your personal information with insurance companies. Other parties with which we share
      your personal information typically include consultants, accountants, and other service providers such as system
      administrators, mobile application developers, couriers, and more. We may also disclose your personal data to
      the competent authorities in the cases provided by law.</p>
    <p style={{ paddingTop: "2pt", paddingLeft: "41pt", textIndent: "0pt", lineHeight: "25pt", textAlign: "justify" }}>
      Amaranth
      Bulgaria processes personal data using servers located within the European Union. Amaranth Bulgaria does not
      make or plan transfers of personal data outside the countries of the</p>
    <p style={{ paddingLeft: "5pt", textIndent: "0pt", lineHeight: "11pt", textAlign: "justify" }}>
      Agreement on the European
      Economic Area (EEA), but in case of such transfer, the company ensures that</p>
    <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}>
      the respective country provides an adequate level
      of personal data protection or Amaranth Bulgaria will require from its partner established in that country to
      conclude Standard Contractual Clauses (SCCs) in order to protect the transferred personal data. In case of data
      transfer outside the EEA, Amaranth Bulgaria will promptly inform the users of the Mobile Application for SCCs
      concluded with partners outside the EEA.</p>
    <p style={{ paddingTop: '11pt', paddingLeft: '5pt', textIndent: '35pt', textAlign: 'justify' }}>
      To protect your personal data,
      we have implemented a system of technical and organizational measures aimed at protecting your privacy. These
      measures include the development and implementation of Amaranth Bulgaria&#39;s personal data Policies, the
      introduction of software solutions such as firewalls, anti- virus and anti-malware software; the introduction of
      guarantees that all documents and information are exchanged through secure and encrypted channels, as well as
      the appointment of a data protection Officer to oversee the implementation of these measures. Our employees are
      bound by legal and/or contractual obligations of confidentiality, as are our business partners, consultants and
      service providers.</p>
    <p style={{ paddingTop: '11pt', paddingLeft: '5pt', textIndent: '35pt', textAlign: 'justify' }}>
      You have the right at any time
      to be informed whether Amaranth Bulgaria processes your personal data, as well as about the source of data,
      purposes and methods of processing, the logic applied in profiling by electronic means; the data identifying the
      controller and the data processors; the categories of persons to whom your personal data may be disclosed. You
      have the right to access this information in a widely recognized machine-readable format.</p>
    <p style={{ paddingTop: '11pt', paddingLeft: '5pt', textIndent: '35pt', textAlign: 'justify' }}>
      In addition, you have the
      right to request the updating, correction or inclusion of personal data, deletion, conversion into an anonymous
      form or blocking of personal data that have been processed in violation of the law, including data that do not
      need to be maintained for purposes which they have been collected or subsequently processed; a statement that
      the above operations have been disclosed, including in terms of their content, to those parties to whom the data
      have been communicated, except in cases where such implementation proves impossible or requires the use of
      methods which are manifestly disproportionate to protected right. You can also ask if the right of portability
      applies to the specific data subject to your request, as well as request the portability of your data. However,
      you also have the right to object, in part or in full, for lawful reasons, to the processing of your personal
      data for the purposes of direct marketing, market research or behavioral analysis. You have the right to request
      a restriction on any processing you object to.</p>
    <p style={{ paddingTop: '11pt', paddingLeft: '5pt', textIndent: '35pt', textAlign: 'justify' }}>
      You have the right to withdraw
      your consent when the processing by Amaranth Bulgaria is carried out on the basis of your consent (please find
      more information above). Amaranth Bulgaria immediately terminates any processing, the implementation on the
      basis of the withdrawn consent. If you have been asked to renew your consent due to its expiry and you have not
      done so, your consent will be considered withdrawn.</p>
    <p style={{ paddingTop: "2pt", paddingLeft: "5pt", textIndent: "35pt", textAlign: "justify" }}>
      To exercise any of the above
      rights, please send an email to the Data Protection Officer indicating the right(s) you wish to exercise. Your
      application will be considered within one month of receiving it or - in case of particular complexity - 3 months
      after receiving it, during which you will be notified in the first month of what the delay is. Your application
      will be considered free of charge. We reserve the right to request additional information to verify your
      identity. Anonymous requests will not be considered.</p>
    <p style={{ paddingTop: '11pt', paddingLeft: '5pt', textIndent: '35pt', textAlign: 'justify' }}>
      <a
        href="https://www.cpdp.bg/en" className="s2" target="_blank">
        Lastly, you have the right to lodge a complaint
        with the Data Protection Supervisor. The processing of your data and the use of tracking technologies by
        Amaranth Bulgaria are controlled by the Commission for Personal Data Protection of the Republic of Bulgaria,
        website: </a><span
          style={{ color: "#00F", fontFamily: "Calibri, sans-serif", fontStyle: "normal", fontWeight: "normal", textDecoration: "underline", fontSize: "10.5pt" }}>
        https://www.cpdp.bg/en</span><a
          href="mailto:kzld@cpdp.bg" className="s2" target="_blank">
        , e-mail address: </a><span
          style={{ color: "#00F", fontFamily: "Calibri, sans-serif", fontStyle: "normal", fontWeight: "normal", textDecoration: "underline", fontSize: "10.5pt" }}>
        kzld@cpdp.bg</span><a
          href="https://edpb.europa.eu/about-edpb/board/members_en" className="s2" target="_blank">
        , 2 Prof. Tsvetan
        Lazarov Blvd., 1592 Sofia. Depending on your place of establishment, you can contact another data protection
        supervisor within the European Union. A full list of EU supervisors and how to contact them can be found
        here: </a><span
          style={{ color: "#00F", fontFamily: "Calibri, sans-serif", fontStyle: "normal", fontWeight: "normal", textDecoration: "underline", fontSize: "10.5pt" }}>
        https://edpb.europa.eu/about-edpb/board/members_en</span>.
    </p>
    <p style={{ paddingTop: '11pt', paddingLeft: '5pt', textIndent: '35pt', textAlign: 'justify' }}>
      This Privacy Policy has been
      developed in accordance with the General Data Protection Regulation (Regulation 2016/679/EU). To the extent that
      the General Data Protection Regulation does not apply, the legislation of the Republic of Bulgaria will be
      applicable to this Privacy Policy. In the event of changes in applicable legislation, including Regulation
      2016/679/EU, we may need to amend this Policy. We will inform you of any changes in this Policy at the e-mail
      address provided for communication with Amaranth Bulgaria.</p>
  </div>
}

export default PrivacyPolicy